import {
  Button,
  datesToISO,
  Input,
  modalHandler,
  success,
  useCustomForm,
} from "@";
import { useResendCodeMutation } from "../api/mutations";
import {
  resendCodeDefaultValues,
  resendCodeSchema,
} from "../lib/validation.ts";
import type { ResendCodeFormValues } from "../types.ts";

const ResendCodeModal = () => {
  const {
    watch,
    errors,
    reset,
    setValue,
    register,
    handleSubmit,
    isSubmitting,
  } = useCustomForm(resendCodeDefaultValues, resendCodeSchema);

  const resendCodeMutation = useResendCodeMutation();

  // Handle form submission
  const submit = async (form: ResendCodeFormValues) => {
    await resendCodeMutation.mutateAsync({
      fromTime: datesToISO(form.fromTime),
      toTime: datesToISO(form.toTime),
    });
    success("تم اعادة الارسال بنجاح");
    modalHandler("resend-verification-modal");
    reset();
  };

  return (
    <form onSubmit={handleSubmit(submit)} className="p-2 md:p-5">
      <Input
        style="mb-5"
        type="date-range"
        labelA="تاريخ البداية"
        labelB="تاريخ النهاية"
        valueA={watch("fromTime")}
        valueB={watch("toTime")}
        inputA={register("fromTime")}
        inputB={register("toTime")}
        errorA={errors.fromTime}
        errorB={errors.toTime}
        changeA={(e: Date | null) => setValue("fromTime", e)}
        changeB={(e: Date | null) => setValue("toTime", e)}
      />

      <Button
        type="submit"
        className="mt-5"
        title="اعادة ارسال"
        isLoading={isSubmitting}
      />
    </form>
  );
};

export default ResendCodeModal;
